import {
  Box,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  FormControlLabel,
  IconButton,
  FormControl,
  InputLabel,
  Grid,
  Typography,
  Button,
} from "@mui/material";

import Icon from "@mui/material/Icon";
import { useState } from "react";
import MDButton from "theme/components/MDButton";

const ops = ["==", "!=", ">", "<", ">=", "<=", "IN"];

const WhereBuilder = ({ fields, onChange }) => {
  const [useExpr, setUseExpr] = useState(false);
  const [conditions, setConditions] = useState([]);
  const [expr, setExpr] = useState("");

  const buildQuery = () => {
    if (useExpr) {
      onChange(expr);
      return;
    }

    const q = conditions
      .map((c) => {
        if (c.op === "IN") {
          return `${c.field} in [${c.value
            .split(",")
            .map((v) => `'${v.trim()}'`)
            .join(",")}]`;
        }
        return `${c.field} ${c.op} '${c.value}'`;
      })
      .join(" & ");
    onChange(q);
  };

  const addCondition = () => {
    setConditions([...conditions, { field: "", op: "==", value: "" }]);
  };

  const update = (i, k, v) => {
    const copy = [...conditions];
    copy[i][k] = v;
    setConditions(copy);
    setTimeout(buildQuery, 100);
  };

  const remove = (i) => {
    const copy = [...conditions];
    copy.splice(i, 1);
    setConditions(copy);
    setTimeout(buildQuery, 100);
  };

  return (
    <Box>
      <Box align="center">
        <Typography variant="h6" fontSize={14} fontWeight={400}>
          Filter
        </Typography>
      </Box>

      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl sx={{ minWidth: 120, width: "100%" }}>
              <InputLabel>Filter Type</InputLabel>
              <Select
                label="Filter Type"
                value={useExpr}
                onChange={(e) => {
                  setUseExpr(e.target.value);
                  onChange("");
                }}
                defaultValue={false}
                sx={{ padding: "12px", paddingLeft: "3px" }}
                fullWidth
              >
                <MenuItem value={false}>By Field</MenuItem>
                <MenuItem value={true}>Literal Expression</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            {!useExpr ? (
              <Box align="right">
                <MDButton
                  variant="contained"
                  color="dark"
                  onClick={addCondition}
                  startIcon={<Icon>add</Icon>}
                >
                  Add Condition
                </MDButton>
              </Box>
            ) : (
              <TextField
                fullWidth
                label="Enter Expression"
                placeholder="e.g age >= 18"
                value={expr}
                onChange={(e) => {
                  setExpr(e.target.value);
                  onChange(e.target.value);
                }}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      {!useExpr && (
        <Box mt={3}>
          {conditions.map((c, i) => (
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Field</InputLabel>
                  <Select
                    label="Select Field"
                    value={c.field}
                    onChange={(e) => update(i, "field", e.target.value)}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {fields.map((f) => (
                      <MenuItem key={f.key} value={f.key}>
                        {f.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Operator</InputLabel>
                  <Select
                    label="Operator"
                    value={c.op}
                    onChange={(e) => update(i, "op", e.target.value)}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {ops.map((o) => (
                      <MenuItem key={o} value={o}>
                        {o}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField value={c.value} onChange={(e) => update(i, "value", e.target.value)} />
              </Grid>
              <Grid item xs={12} md={1} lg={1}>
                <IconButton onClick={() => remove(i)}>
                  <Icon color="error">clear</Icon>
                </IconButton>
              </Grid>
            </Grid>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default WhereBuilder;
